import { createContext } from 'react';
import { WIDGET_DEVICE_TYPE } from 'components/widget-editor-sidebar/constants/widget-editor-sidebar-devices';

export interface DeviceTypeContextType {
  deviceType: WIDGET_DEVICE_TYPE;
  setDeviceType: React.Dispatch<React.SetStateAction<WIDGET_DEVICE_TYPE>>;
}

export const DeviceTypeContext = createContext<DeviceTypeContextType | undefined>(undefined);
